import { mapState, mapGetters } from 'vuex';

import { ErrorPopup } from '@/core/error-popup';
import { WorkerOneTimePassConstants } from '@/core/worker-one-time-pass';
import { OneTimePassRoutesMixin } from '@/portal/one-time-pass/mixins';

// @vue/component
export default {
  components: {
    ErrorPopup,
  },
  mixins: [
    OneTimePassRoutesMixin,
  ],
  data() {
    return {
      showErrorPopup: false,
    };
  },
  computed: {
    ...mapState({
      contactSupportLink: state => state.config.contactSupportLink,
    }),
    ...mapGetters('oneTimePass', ['isWorkerOneTimePassInProgress', 'unansweredAssessmentFields', 'unfinishedWorkerInductions']),
    ...mapGetters('oneTimePass', {
      clientName: 'oneTimePassClientName',
      workerOneTimePassStatus: 'workerOneTimePassStatus',
    }),
    firstUnfinishedRoute() {
      const firstUnansweredAssessmentField = this.unansweredAssessmentFields[0];
      if (firstUnansweredAssessmentField) {
        return _.merge({}, this.routes.assessment, {
          params: { assessmentFieldUuid: firstUnansweredAssessmentField.uuid },
        });
      }

      const firstUnfinishedInduction = this.unfinishedWorkerInductions[0];
      if (firstUnfinishedInduction) {
        return _.merge({}, this.routes.induction, {
          params: { inductionUuid: firstUnfinishedInduction.uuid },
        });
      }

      return this.routes.assessment;
    },
    isWorkerOneTimePassRedeemed() {
      return this.workerOneTimePassStatus === _.get(WorkerOneTimePassConstants, 'current_status.redeemed.key');
    },
    errorPopupConfig() {
      return {
        errorHeading: `Sorry, you're not eligible for a one time use pass`,
        errorText: `In order to check-in at this location, you will need to complete all outstanding compliance requirements.
          Please contact your employer or <a href="${this.contactSupportLink}" target="_blank">iPRO support</a>.`,
      };
    },
  },
  methods: {
    checkStatusAndRedirect() {
      if (this.isWorkerOneTimePassRedeemed) {
        this.showErrorPopup = true;
      } else {
        this.$router.push(this.firstUnfinishedRoute);
      }
    },
  },
};
